export default {
  description: 'Erstellen und verwalten Sie Ihr Voreinstellungen',
  presetLabel: 'Ausgewählte Voreinstellung',
  nameLabel: 'Voreinstellungsname',
  saveAsDefault: 'Voreinstellung als Standard speichern',
  publishGlobaly: 'Für alle Benutzer veröffentlichen',
  publishGlobalyTooltip: 'Um diese Einstellung zu ändern, kopieren Sie eine vorhandene Voreinstellung oder erstellen Sie ein neue Voreinstellung',
  defaultName: 'Neue Voreinstellung',
  selectPreset: 'Eine Voreinstellung auswählen',
  reset: 'Zurücksetzen',
  apply: 'Ohne Speichern anwenden',
};
